import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Logowanie.css';

const API_URL = process.env.REACT_APP_API_URL;

function Logowanie({ onZaloguj }) {
    const [login, setLogin] = useState('');
    const [haslo, setHaslo] = useState('');
    const [blad, setBlad] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBlad(null);

        try {
            const response = await axios.post(`${API_URL}/logowanie`, { login, haslo });

            const { token, refreshToken, uzytkownik } = response.data;
if (token && uzytkownik) {
    localStorage.setItem('token', token);
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }
    localStorage.setItem('uzytkownik', JSON.stringify(uzytkownik));
        onZaloguj(token, refreshToken, uzytkownik);
    navigate('/');
} else {
    setBlad('Nieprawidłowe dane logowania.');
}
        } catch (err) {
            setBlad('Błąd logowania: ' + (err.response?.data?.error || 'Spróbuj ponownie.'));
        }
    };

    return (
        <div className='login-container'>
            <h2>Logowanie</h2>
            
            {/* Dodana klasa dla ładniejszego wyświetlania błędu */}
            {blad && <p className="error-message">{blad}</p>}
            
            <form className='login-form' onSubmit={handleSubmit}>
                {/* Dodana klasa form-group do owijania labeli i inputów */}
                <div className="form-group">
                    <label htmlFor="login">Login:</label>
                    <input 
                        id="login"
                        className='login-input' 
                        type="text" 
                        value={login} 
                        onChange={(e) => setLogin(e.target.value)} 
                        required 
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="password">Hasło:</label>
                    <input 
                        id="password"
                        className='login-input' 
                        type="password" 
                        value={haslo} 
                        onChange={(e) => setHaslo(e.target.value)} 
                        required 
                    />
                </div>
                
                <button type="submit">Zaloguj</button>
            </form>
        </div>
    );
}

export default Logowanie;
